import { render, staticRenderFns } from "./contactCategory.vue?vue&type=template&id=2c9c5e2e&"
import script from "./contactCategory.vue?vue&type=script&lang=js&"
export * from "./contactCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports